import { Link } from 'react-router';
import { CategoryCards } from './CategoryCards';
import { CommunityGuidelines } from './CommunityGuidelines';
import { FeaturedTopics } from './FeaturedTopics';

/**
 * The forum's home page — welcome banner, quick actions, category cards, a
 * featured-topics preview, the moderation notice, and the condensed
 * community guidelines. See the Phase 3 plan for what was deliberately left
 * out (Recognition & Success, "Trending" as a distinct sort). The
 * MortgageMAX Platform tiles (MortgageMAX360/PQs/Bonds/Announcements linking
 * out to mortgagemax.co.za) that used to sit here were removed on request.
 */
export function LandingPage({ displayName }: { displayName: string }): React.JSX.Element {
  return (
    <div className="landing-page">
      <section className="hero-banner" aria-labelledby="hero-heading">
        <p className="hero-greeting" data-testid="greeting">
          Hello, {displayName}
        </p>
        <div className="hero-heading-row">
          <h2 id="hero-heading">Welcome to the MortgageMAX Forum</h2>
          <Link to="/discussions" className="button" data-testid="hero-cta">
            Join the Discussion
          </Link>
        </div>
        <p>
          A space for MortgageMAX platform users and BetterHome colleagues to discuss ideas,
          report issues, and help each other get the most out of the platform.
        </p>
      </section>

      <section aria-labelledby="quick-actions-heading">
        <h2 id="quick-actions-heading">Quick Actions</h2>
        <ul className="quick-actions">
          <li>
            <Link to="/discussions" className="button small" data-testid="quick-action-start">
              Start a Discussion
            </Link>
          </li>
          <li>
            <a href="#guidelines" className="button small secondary" data-testid="quick-action-guidelines">
              View Community Guidelines
            </a>
          </li>
          <li>
            <a
              href="mailto:csc@betterhome.co.za"
              className="button small secondary"
              data-testid="quick-action-support"
            >
              Contact Support
            </a>
          </li>
        </ul>
      </section>

      <CategoryCards />

      <FeaturedTopics />

      <p className="notice" data-testid="moderation-notice">
        To maintain a constructive environment, posts containing sensitive or potentially
        inappropriate content are automatically flagged and may be held for a moderator to review
        before they become visible to others.
      </p>

      <CommunityGuidelines />
    </div>
  );
}
